module.exports = __webpack_public_path__ + "static/media/white.bc3e161a.png";